module.exports = __webpack_public_path__ + "static/img/9.3782fc3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1/boxopen/9.png
// module id = oqGq
// module chunks = 1